import { buildLineGraphData } from "../../Dashboards/utils/lineGraphData";

export function applyLineGraphState(
  targetState,
  lineGraphSourceData,
  chosenTime,
  now
) {
  targetState.lineGraphSourceData = lineGraphSourceData;
  targetState.lineGraphDerivedData = buildLineGraphData({
    lineGraphSourceData,
    chosenTime,
    now,
  });
}
